var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "add-bill"
  }, [_c('b-modal', {
    attrs: {
      "dialog-class": "dialog-class",
      "size": "lg",
      "centered": "",
      "title": _vm.dataRefillForBill ? _vm.$t('ar_client_edit_pay') : _vm.$t('ar_client_add_pay'),
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.clearValueInput
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('validation-observer', {
    ref: "formRef"
  }, [_c('b-row', {
    staticClass: "m-0 mt-1 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "label-requires",
    attrs: {
      "label": _vm.$t('ar_client_cashier'),
      "label-cols": "3"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.$t('ar_client_cashier'),
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var errors = _ref.errors;
        return [_c('v-select', {
          attrs: {
            "options": _vm.listDataCashier,
            "label": "CashierName",
            "placeholder": _vm.$t('ar_client_select_payer')
          },
          model: {
            value: _vm.cashierVal,
            callback: function ($$v) {
              _vm.cashierVal = $$v;
            },
            expression: "cashierVal"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "label-requires",
    attrs: {
      "label": _vm.$t('ar_client_payments'),
      "label-cols": "3"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.$t('ar_client_payments'),
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var errors = _ref2.errors;
        return [_c('b-form-select', {
          model: {
            value: _vm.payerVal,
            callback: function ($$v) {
              _vm.payerVal = $$v;
            },
            expression: "payerVal"
          }
        }, [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v(_vm._s(_vm.$t("ar_client_payments")))]), _vm._l(_vm.listPayment[0].PaymentMethod, function (item, index) {
          return _c('b-form-select-option-group', {
            key: index,
            attrs: {
              "label": item.Name
            }
          }, _vm._l(item.TransactionCode, function (itemMethod, index) {
            return _c('b-form-select-option', {
              key: index,
              attrs: {
                "value": {
                  Group: item,
                  Option: itemMethod
                }
              }
            }, [_vm._v(" " + _vm._s(itemMethod.Description) + " ")]);
          }), 1);
        })], 2), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "label-requires",
    attrs: {
      "label": _vm.$t('ar_voucher_type_currency'),
      "label-cols": "3"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.$t('ar_voucher_type_currency'),
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var errors = _ref3.errors;
        return [_c('v-select', {
          attrs: {
            "options": _vm.listCurrencyLocalStorage,
            "placeholder": _vm.$t('ar_client_select_type_currency'),
            "label": "CurrencyCode"
          },
          model: {
            value: _vm.typeCurrencyVal,
            callback: function ($$v) {
              _vm.typeCurrencyVal = $$v;
            },
            expression: "typeCurrencyVal"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "label-requires",
    attrs: {
      "label": _vm.$t('ar_client_input_money_number'),
      "label-cols": "3"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.$t('ar_client_input_money_number'),
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-input', {
          model: {
            value: _vm.dataInputForm.Amount,
            callback: function ($$v) {
              _vm.$set(_vm.dataInputForm, "Amount", $$v);
            },
            expression: "dataInputForm.Amount"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('ar_voucher_note'),
      "label-cols": "1"
    }
  }, [_c('b-form-textarea', {
    model: {
      value: _vm.dataInputForm.Note,
      callback: function ($$v) {
        _vm.$set(_vm.dataInputForm, "Note", $$v);
      },
      expression: "dataInputForm.Note"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "w-100 border-top d-flex justify-content-end align-items-center p-1"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.acceptDataSave
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_save")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }